<template>
  <div id="page">
<!--    -->
    <div class="background-content">
      <div class="stage-main">
        <div class="layer" v-if="progressNum < 99.99">
          <p>资源加载中...</p>
          <div class="border">
            <div class="progress" :style="{width: progressNum + '%'}"></div>
          </div>
        </div>
        <identity-select v-else-if="step < 2 && !hanUserInfo" :step="step" :init-info="userInfo" @on-change-user="handleChangeUserInfo" @on-save="submitVirtualization"></identity-select>
        <div v-if="step === 2 && hanUserInfo && progressNum > 99.99" class="setting-btn" @click="handleClickSetting"></div>
        <div class="view-cv-outer" @click="showCvList = true "  v-if="alreadyLogged && progressNum > 99.99 && step === 2">
          <div class="view-cv"></div>
        </div>
        <canvas class="space-content"></canvas>

      </div>
      <div class="keyword-box">
        <keyboard-box @on-keyboard="handleClickKeyboard"></keyboard-box>
      </div>
    </div>
    <div class="sign-in-box" v-if="isShowSignBox">
      <i class="iconGroup11 iconfont" @click="close"></i>
      <div :class="['sign-in', isShowSubscribeLive ? 'subscribe' : '']">
        <div class="sign-in-btn" @click="handleClickSignIn(isShowSubscribeLive)"></div>
      </div>
    </div>
    <div class="sign-in-box" v-if="isShowLiveBox">
      <i class="iconGroup11 iconfont" @click="close"></i>
      <div :class="['live-box']">
        <img  src="https://files.wondercv.com/Game/H5/banner.png" @click.stop="handleClickToDetail"/>
      </div>
    </div>
    <div class="banner-in-box" v-if="showBanner" @click="bannerToLink">
      <img :src="bannerUrl" alt="" srcset="" class="banner-in-box-img" >
      <i class="iconGroup11 iconfont" @click.stop="showBanner = false; isCloseLive = true;"></i>
    </div>
    
    <div class="mask" v-if="showCvList || showBanner"></div>
    <transition name="fade">
      <div class="cv-list" v-if="showCvList">
        <div class="no-resume-tips" v-if="!cvList.length">
          <img src="https://files.wondercv.com/Game/resume_default.png" alt="" srcset="" class="no-resume">
          <div class="no-resume-text">暂无简历信息</div>
        </div>
        <div class="resume-list">
          <!-- 创建在线简历入口 模块 -->
          <div class="no-online-cv-box" v-if="(cvInvisibileVisible || createOnlineCvVisible) && cvList.length" />
          <!-- 在线简历展示 模块 -->
          <div class="online-cv-box" v-if="onlineCvModuleVisible">
            <div class="cv-count" style="margin-left: 27px">推荐中简历</div>
            <div class="online-cv-content" @click="onlineCvPreview">

              <div class="online-cv-content-left">
                <img class="online-cv-avatar" :src="onlineCv.resume.info.profile.avatar_url || personInfo.avatar_url || 'https://wondercv-public-resource.oss-cn-beijing.aliyuncs.com/avatars/avatars4.png'" alt="">
                <div class="online-cv-info">
                  <span class="online-cv-title">{{ onlineCv.resume.info.profile.username }}</span>

                  <template v-if="is_student && onlineCv.resume.info && onlineCv.resume.info.education_experiences && onlineCv.resume.info.education_experiences.length">
                    <span class="online-cv-tag orange school" v-if="onlineCv.resume.info.education_experiences[0].cust_uni_name || onlineCv.resume.info.education_experiences[0].school.cn">{{ onlineCv.resume.info.education_experiences[0].cust_uni_name || onlineCv.resume.info.education_experiences[0].school.cn }}</span>
                    <span class="online-cv-tag degree" v-if="onlineCv.resume.info.education_experiences[0].cust_degree || onlineCv.resume.info.education_experiences[0].degree_name.cn">{{ onlineCv.resume.info.education_experiences[0].cust_degree || onlineCv.resume.info.education_experiences[0].degree_name.cn }}</span>
                  </template>
                  <template v-if="!is_student && onlineCv.resume.info && ((onlineCv.resume.info.work_experiences && onlineCv.resume.info.work_experiences.length) || (onlineCv.resume.info.internship_experiences.length))">
                    <span class="online-cv-tag">{{ (onlineCv.resume.info.work_experiences[0] || onlineCv.resume.info.internship_experiences[0]) | workTitleFilter }}</span>
                  </template>

                  <span class="online-cv-time">{{ moment(onlineCv.resume.updated_at).format('YYYY年MM月DD日 HH:mm') }}</span>
                </div>
              </div>

              <!--                  <div class="online-cv-content-right">-->
              <!--                    <button class="online-cv-btn update" v-if="isUpdated || isPerfect" @click.stop="debounce(() => { triggerUpdateOnlineCvFunc() }, 300)">更新</button>-->
              <!--                  </div>-->

            </div>

          </div>
          <div class="cv-count" v-if="cvList.length">共有{{cvList.length}}份简历</div>
          <div style="overflow: auto; height: 378px;" :style="{height: onlineCvModuleVisible ? '258px' : '308px'}" v-if="cvList.length">
            <div class="resume-item" v-for="item in cvList" :key="item.token" @click="toCvEditor(item.token)">
              <img :src="item.avatar_url ||'https://files.wondercv.com/PC/cvs/myresume_red.png'" alt="" class="cv-avatar">
              <div>
                <div class="cv-name">{{item.cv_name}}</div>
                <div class="cv-update-time">{{timeFormatFilter(item.update_time)}}</div>
              </div>
            </div>
          </div>
          <div class="create-cv" @click="$router.push({path: '/cvs'})"></div>
        </div>
        <div class="close-btn" @click="showCvList = false" v-if="showCvList"></div>
      </div>
    </transition>
  </div>
</template>

<script>
  import {Application, Container, Loader, Sprite, Graphics} from "pixi.js";
  import { keyboard, spriteForImageOrAnimatedSprite, hitTestRectangleByList, direction, hitTestRectangle, get_tUser } from "../../assets/js/utils"
  import KeyboardBox from "../../components/space/KeyboardBox";
  import IdentitySelect from "./components/identity-select"
  import {loginMixin} from "../../assets/js/mixin/global";
  import moment from "moment"
  import api from '../../api/api-list'
  const keyboardVx = {
    up: 0,
    down: 0,
    left: -4,
    right: 4
  }
  const keyboardVy = {
    up: -4,
    down: 4,
    left: 0,
    right: 0
  }
  const keyboardAnimateStart = {
    up: (that) => {that.user.gotoAndStop(0)},
    down: (that) => {that.user.gotoAndStop(1)},
    left: (that) => {that.user.gotoAndPlay(2)},
    right: (that) => {that.user.gotoAndPlay(5)}
  }
  const keyboardAnimateStop = {
    up: (that) => {that.user.gotoAndStop(0)},
    down: (that) => {that.user.gotoAndStop(1)},
    left: (that) => {that.user.gotoAndStop(2)},
    right: (that) => {that.user.gotoAndStop(5)}
  }
  export default {
    name: "space",
    components: {KeyboardBox, IdentitySelect},
    mixins: [loginMixin],
    data(){
      return {
        //主体游戏
        spaceApp: null,
        //缩放
        zoom:0.55,
        //屏幕高度
        clientHeight: 0,
        //屏幕宽度
        clientWidth: 0,
        //地图容器
        gameScene: null,
        //产生碰撞的集合
        crashItem: [],
        //缩放后的地图大小
        canvasWidth: 2100 * 0.55,
        canvasHeight: 1671 * 0.55,
        //进度条
        progressNum: 0,
        //选择身份的步骤
        step: 0,
        //当前登录用户是否有虚拟人物身份
        hanUserInfo: false,
        //用户的信息
        userInfo: {
          gender: 0,
          hair_color: 0,
          hair_style: 0,
          suit: 0,
          user_identity: "",
          username: ""
        },
        //虚拟形象
        user: null,
        userResources: "",
        sign_in: null,//签到(预约)碰撞的矩形
        live_Box: null,//直播弹窗
        isSignIn: false,//是否签到
        isShowSignBox: false,//是否显示签到(预约)弹窗
        liveToken: "",//直播token
        isSubscribeLive: false,//是否预约过
        isShowSubscribeLive: false,//是否可预约
        isShowLiveBox: false,//显示直播弹窗
        showCvList: false, // 显示简历
        cvList: [], // 简历列表
        isCloseSignIn: false,
        showMask: false,
        showMaskUrlType: 0,
        bannerUrl: "",
        showBanner: false,
        iframeUrl: "",
        t_user:{},
        cv_invisibile: false,   // 简历是否公开
        onlineCv: {},   // 在线简历
        cvIsRecommend: false,  // 简历是否被推荐
        onlineCvIndex: -1,  // 在线简历在简历列表中的位置
        is_student: false,   // 是否是学生
        is_intention: false,   // 是否有求职意向
      }
    },
    filters: {
      workTitleFilter(val) {
        if (!val) return
        return val.title
      }
    },
    watch: {
      cvList: {
        deep: true,
        handler(val) {
          this.getOnlineCv()
        }
      }
    },
    created(){
      this.t_user = get_tUser();
      if (!this.t_user.c_t){
        this.$router.push(`/blackboard/login`)
        return
      }
    },
    async mounted() {
      // 必须登录
      if (!this.t_user.c_t){
        return
      }
      this.initData()
      if (!this.alreadyLogged) {
        this.needLogin()
      }
      await this.getVirtualization()
      // 初始化画布
      this.getUserInfo()
      this.initGame();
      this.getCvList();
    },
    computed: {
      /**
       * 显示在线简历模块条件：
       * 1. 获取在线简历接口完成 【isLoaderOnline】
       * 2. 隐私设置没有关闭 【!cv_invisibile】
       * 3. 接口返回的数据 res.data.resume.resume 有值 【onlineCv.resume】
       * 4. 接口返回的数据 res.data.resume.resume.info 有值 【onlineCv.resume.info】
       * 5. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getIsOnlineCv()】
       */
      onlineCvModuleVisible () {
        return !this.cv_invisibile && this.onlineCv.resume && this.onlineCv.resume.info && this.getIsOnlineCv()
      },
      /**
       * 显示跳转到开启隐私按钮条件：
       * 1. 隐私设置关闭了
       * 2. 有可以生成在线简历的简历
       */
      cvInvisibileVisible () {
        return this.cv_invisibile && this.getIsOnlineCv()
      },
      /**
       * 显示创建在线简历入口条件：
       * 1. 隐私设置没有关闭 【!cv_invisibile】
       * 2. 有满足生成在线简历条件的简历（中文简历、可编辑、不为导师） 【getIsOnlineCv()】
       * 3. 接口返回的数据 res.data.resume 没有有值 【onlineCv】
       * 4. 接口返回的数据 res.data.resume.resume 没有有值 【onlineCv.resume】
       */
      createOnlineCvVisible () {
        return !this.cv_invisibile && this.getIsOnlineCv() && !(this.onlineCv && this.onlineCv.resume)
      },
    },
    methods: {
      moment,
      // 获取账号信息
      getUserInfo() {
        this.$api.space.getUserInfo(this.t_user.c_t).then(res => {
          if (res.code === 1000) {
            this.is_intention = res.data.intention
            this.is_student = res.data.is_student;
          }
        })
      },
      // 在线简历预览
      onlineCvPreview() {
        this.$router.push({path: '/cvs'})
      },
      // 创建在线简历
      triggerCreateOnlineCvFunc() {
        this.$router.push({path: '/cvs'})
      },
      // 获取简历是否可以生成在线简历
      getIsOnlineCv() {
        let isTrue = false;
        let cvs = this.cvList;
        for (let i = 0; i < cvs.length; i++) {
          if (cvs[i].lang === 'cn' && cvs[i].can_editable && !cvs[i].is_mentor) {
            isTrue = true;
            break;
          }
        }
        return isTrue;
      },
      // 获取在线简历
      async getOnlineCv() {
        try {
          let cvInvisibileRes = await this.$api.space.getCvInvisible(this.t_user.c_t)
          if (cvInvisibileRes.code === 1000) {
            this.cv_invisibile = cvInvisibileRes.data.cv_invisibile || false;
          } else {
            console.log(res.message)
          }
          let onlineCvRes = await api.space.getOnlineCv(this.t_user.c_t)
          if (onlineCvRes.code === 1000) {
            this.cvIsRecommend = true
            let onlineCv = onlineCvRes.data && onlineCvRes.data.resume || onlineCvRes.data || {};
            if(onlineCv.resume){
              let doesItExist =  this.cvList.findIndex(item=>{
                return item.token === onlineCv.resume.token
              })
              if(doesItExist<0){
                onlineCv = {}
              } else {
                this.onlineCvIndex = doesItExist
              }
            }
            this.onlineCv = onlineCv
          } else {
            console.log(res.message)
          }
        } catch (e) {
          console.error(e)
        }
      },
      //初始化游戏
      initGame(){
        let gamContent = document.querySelector(".space-content")
        const {clientHeight, clientWidth} = document.body
        this.clientHeight = clientHeight
        this.clientWidth = clientWidth
        this.spaceApp = new Application({
          antialiasing: true,
          transparent: false,
          resolution: 1,
          view: gamContent,
          height: 462,
          width: 343,
          backgroundColor: 0xffffff
        });
        this.spaceApp.sortableChildren = true
        this.loader = new Loader()
        this.loader
          .add("leftWall", 'https://files.wondercv.com/Game/zuoyouqiang.png')
          .add("upWall", 'https://files.wondercv.com/Game/character/qiang5.png')
          .add("bottomWall", 'https://files.wondercv.com/Game/diqiang.png')
          .add("leftFirstPicture", "https://files.wondercv.com/Game/guahua.png")
          .add("leftFirstChest", "https://files.wondercv.com/Game/guizi.png")
          .add("leftFirstFloor", "https://files.wondercv.com/Game/character/diban2.png")
          .add("leftFirstBoard", "https://files.wondercv.com/Game/baiban.png")
          .add("leftFirstBotany", "https://files.wondercv.com/Game/zhiwu.png")
          .add("leftFirstSofa", "https://files.wondercv.com/Game/zhuoyi5.png")
          .add("leftFirstOutWall", "https://files.wondercv.com/Game/character/shuqiang1.png")
          .add("leftSecondInnerWall", "https://files.wondercv.com/Game/character/qiang4.png")
          .add("leftSecondScreen", "https://files.wondercv.com/Game/yingmu3.png")
          .add("leftSecondFloor", "https://files.wondercv.com/Game/character/diban3.png")
          .add("leftSecondOutWall", "https://files.wondercv.com/Game/character/shuqiang2.png")
          .add("leftSecondOutTv", "https://files.wondercv.com/Game/dianshigui.png")
          .add("leftSecondSofa", "https://files.wondercv.com/Game/zhuoyi4.png")
          .add("leftThirdInnerWall", "https://files.wondercv.com/Game/qiang3.png")
          .add("leftThirdPic", "https://files.wondercv.com/Game/yingmu2.png")
          .add("leftThirdSound", "https://files.wondercv.com/Game/yinxiang.png")
          .add("leftThirdFloor", "https://files.wondercv.com/Game/diban4.png")
          .add("leftThirdPlatform", "https://files.wondercv.com/Game/jiangtai1.png")
          .add("leftThirdBotany", "https://files.wondercv.com/Game/zhiwu.png")
          .add("leftThirdChair", "https://files.wondercv.com/Game/zuhezuoyi.png")
          .add("leftThirdOutWallOne", "https://files.wondercv.com/Game/character/shuqiang3.png")
          .add("leftThirdOutWallTwo", "https://files.wondercv.com/Game/shuqiang4.png")
          .add("hallFloor", "https://files.wondercv.com/Game/character/diban1.png")
          .add("hallModel", "https://files.wondercv.com/Game/moxing.png")
          .add("hallPoster", "https://files.wondercv.com/Game/haibao2.png")
          .add("hallScreen", "https://files.wondercv.com/Game/character/yingmu1.png")
          .add("hallPosterTwo", "https://files.wondercv.com/Game/haibao1.png")
          .add("hallPlatform", "https://files.wondercv.com/Game/jiangtai2.png")
          .add("hallDeliver", "https://files.wondercv.com/Game/toudichu.png")
          .add("hallBookRack", "https://files.wondercv.com/Game/shujia.png")
          .add("hallWindow", "https://files.wondercv.com/Game/chaunghu.png")
          .add("hallChair", "https://files.wondercv.com/Game/character/zhuoyi3.png")
          .add("hallInnerWall", "https://files.wondercv.com/Game/character/qiang2.png")
          .add("hallPrinter", "https://files.wondercv.com/Game/dayinji.png")
          .add("hallRefrigerator", "https://files.wondercv.com/Game/character/bingxiang.png")
          .add("hallSofa", "https://files.wondercv.com/Game/character/zhuoyi1.png")
          .add("hallJoinWall", "https://files.wondercv.com/Game/qiang1.png")
          .add("hallDispenser", "https://files.wondercv.com/Game/yinshuiji.png")
          .add("hallReception", "https://files.wondercv.com/Game/qiantaizhuo.png")
          .add("hallCard", "https://files.wondercv.com/Game/qiandaochu.png")
          .add("hallCarpet", "https://files.wondercv.com/Game/ditan.png")
          .add("hallCenterChair1", "https://files.wondercv.com/Game/character/zuoyi2.1.png")
          .add("hallCenterChair2", "https://files.wondercv.com/Game/character/zuoyi2.png")
          .add("hallCenterChair3", "https://files.wondercv.com/Game/character/zuoyi2.2.png")
          .add("welcome","https://files.wondercv.com/Game/character/welcome.png")
          .add("zhuoyi7", "https://files.wondercv.com/Game/character/zhuoyi7.png")
          .add("user", "https://files.wondercv.com/Game/character/move/girl_hair3_red_suit3.png")
          .add("gender_normal", "https://files.wondercv.com/Game/character/H5/gender_normal.png")
          .add("gender_press","https://files.wondercv.com/Game/character/H5/gender_press.png")
          .add("hair_normal","https://files.wondercv.com/Game/character/H5/hair_normal.png")
          .add("hair_press","https://files.wondercv.com/Game/character/H5/hair_press.png")
          .add("color_normal","https://files.wondercv.com/Game/character/H5/color_normal.png")
          .add("color_press","https://files.wondercv.com/Game/character/H5/color_press.png")
          .add("suit_normal", "https://files.wondercv.com/Game/character/H5/suit_normal.png")
          .add("suit_press", "https://files.wondercv.com/Game/character/H5/suit_press.png")
          .add("boy","https://files.wondercv.com/Game/character/boy/hari1/brown/suit1.png")
          .add("girl", "https://files.wondercv.com/Game/character/girl/hari1/brown/suit1.png")
          .add("boy_normal","https://files.wondercv.com/Game/character/H5/boy_normal.png")
          .add("boy_press","https://files.wondercv.com/Game/character/H5/boy_press.png")
          .add("girl_normal","https://files.wondercv.com/Game/character/H5/girl_normal.png")
          .add("girl_press","https://files.wondercv.com/Game/character/H5/girl_press.png")
          .add("boy_hair1_normal","https://files.wondercv.com/Game/character/H5/boy_hair1_normal.png")
          .add("boy_hair1_press","https://files.wondercv.com/Game/character/H5/boy_hair1_press.png")
          .add("boy_hair2_normal","https://files.wondercv.com/Game/character/H5/boy_hair2_normal.png")
          .add("boy_hair2_press","https://files.wondercv.com/Game/character/H5/boy_hair2_press.png")
          .add("boy_hair3_normal","https://files.wondercv.com/Game/character/H5/boy_hair3_normal.png")
          .add("boy_hair3_press","https://files.wondercv.com/Game/character/H5/boy_hair2_press.png")
          .add("girl_hair1_normal","https://files.wondercv.com/Game/character/H5/girl_hair1_normal.png")
          .add("girl_hair1_press","https://files.wondercv.com/Game/character/H5/girl_hair1_press.png")
          .add("girl_hair2_normal","https://files.wondercv.com/Game/character/H5/girl_hair2_normal.png")
          .add("girl_hair2_press","https://files.wondercv.com/Game/character/H5/girl_hair2_press.png")
          .add("girl_hair3_normal","https://files.wondercv.com/Game/character/H5/girl_hair3_normal.png")
          .add("girl_hair3_press","https://files.wondercv.com/Game/character/H5/girl_hair2_press.png")
          .add("brown_normal", "https://files.wondercv.com/Game/character/H5/brown_normal.png")
          .add("brown_press", "https://files.wondercv.com/Game/character/H5/brown_press.png")
          .add("gray_normal", "https://files.wondercv.com/Game/character/H5/gray_normal.png")
          .add("gray_press", "https://files.wondercv.com/Game/character/H5/gray_press.png")
          .add("red_normal", "https://files.wondercv.com/Game/character/H5/red_normal.png")
          .add("red_press", "https://files.wondercv.com/Game/character/H5/red_press.png")
          .add("suit1_normal", "https://files.wondercv.com/Game/character/H5/suit1_normal.png")
          .add("suit1_press", "https://files.wondercv.com/Game/character/H5/suit1_press.png")
          .add("suit2_normal", "https://files.wondercv.com/Game/character/H5/suit2_normal.png")
          .add("suit2_press", "https://files.wondercv.com/Game/character/H5/suit2_press.png")
          .add("suit3_normal", "https://files.wondercv.com/Game/character/H5/suit3_normal.png")
          .add("suit3_press", "https://files.wondercv.com/Game/character/H5/suit3_press.png")
          .add("suit4_normal", "https://files.wondercv.com/Game/character/H5/suit4_normal.png")
          .add("suit4_press", "https://files.wondercv.com/Game/character/H5/suit4_press.png")
          .add("user-preview-0", "https://files.wondercv.com/Game/character/girl/hari1/brown/suit1.png")
          .add("user-preview-1", "https://files.wondercv.com/Game/character/girl/hari1/brown/suit2.png")
          .add("user-preview-2", "https://files.wondercv.com/Game/character/girl/hari1/brown/suit3.png")
          .add("user-preview-3", "https://files.wondercv.com/Game/character/girl/hari1/gray/suit1.png")
          .add("user-preview-4", "https://files.wondercv.com/Game/character/girl/hari1/gray/suit2.png")
          .add("user-preview-5", "https://files.wondercv.com/Game/character/girl/hari1/gray/suit3.png")
          .add("user-preview-6", "https://files.wondercv.com/Game/character/girl/hari1/red/suit1.png")
          .add("user-preview-7", "https://files.wondercv.com/Game/character/girl/hari1/red/suit2.png")
          .add("user-preview-8", "https://files.wondercv.com/Game/character/girl/hari1/red/suit3.png")
          .add("user-preview-9", "https://files.wondercv.com/Game/character/girl/hari2/brown/suit1.png")
          .add("user-preview-10", "https://files.wondercv.com/Game/character/girl/hari2/brown/suit2.png")
          .add("user-preview-11", "https://files.wondercv.com/Game/character/girl/hari2/brown/suit3.png")
          .add("user-preview-12", "https://files.wondercv.com/Game/character/girl/hari2/gray/suit1.png")
          .add("user-preview-13", "https://files.wondercv.com/Game/character/girl/hari2/gray/suit2.png")
          .add("user-preview-14", "https://files.wondercv.com/Game/character/girl/hari2/gray/suit3.png")
          .add("user-preview-15", "https://files.wondercv.com/Game/character/girl/hari2/red/suit1.png")
          .add("user-preview-16", "https://files.wondercv.com/Game/character/girl/hari2/red/suit2.png")
          .add("user-preview-17", "https://files.wondercv.com/Game/character/girl/hari2/red/suit3.png")
          .add("user-preview-18", "https://files.wondercv.com/Game/character/girl/hari3/brown/suit1.png")
          .add("user-preview-19", "https://files.wondercv.com/Game/character/girl/hari3/brown/suit2.png")
          .add("user-preview-20", "https://files.wondercv.com/Game/character/girl/hari3/brown/suit3.png")
          .add("user-preview-21", "https://files.wondercv.com/Game/character/girl/hari3/gray/suit1.png")
          .add("user-preview-22", "https://files.wondercv.com/Game/character/girl/hari3/gray/suit2.png")
          .add("user-preview-23", "https://files.wondercv.com/Game/character/girl/hari3/gray/suit3.png")
          .add("user-preview-24", "https://files.wondercv.com/Game/character/girl/hari3/red/suit1.png")
          .add("user-preview-25", "https://files.wondercv.com/Game/character/girl/hari3/red/suit2.png")
          .add("user-preview-26", "https://files.wondercv.com/Game/character/girl/hari3/red/suit3.png")
          .add("user-preview-27", "https://files.wondercv.com/Game/character/boy/hari1/brown/suit1.png")
          .add("user-preview-28", "https://files.wondercv.com/Game/character/boy/hari1/brown/suit2.png")
          .add("user-preview-29", "https://files.wondercv.com/Game/character/boy/hari1/brown/suit4.png")
          .add("user-preview-30", "https://files.wondercv.com/Game/character/boy/hari1/gray/suit1.png")
          .add("user-preview-31", "https://files.wondercv.com/Game/character/boy/hari1/gray/suit2.png")
          .add("user-preview-32", "https://files.wondercv.com/Game/character/boy/hari1/gray/suit4.png")
          .add("user-preview-33", "https://files.wondercv.com/Game/character/boy/hari1/red/suit1.png")
          .add("user-preview-34", "https://files.wondercv.com/Game/character/boy/hari1/red/suit2.png")
          .add("user-preview-35", "https://files.wondercv.com/Game/character/boy/hari1/red/suit4.png")
          .add("user-preview-36", "https://files.wondercv.com/Game/character/boy/hari2/brown/suit1.png")
          .add("user-preview-37", "https://files.wondercv.com/Game/character/boy/hari2/brown/suit2.png")
          .add("user-preview-38", "https://files.wondercv.com/Game/character/boy/hari2/brown/suit4.png")
          .add("user-preview-39", "https://files.wondercv.com/Game/character/boy/hari2/gray/suit1.png")
          .add("user-preview-40", "https://files.wondercv.com/Game/character/boy/hari2/gray/suit2.png")
          .add("user-preview-41", "https://files.wondercv.com/Game/character/boy/hari2/gray/suit4.png")
          .add("user-preview-42", "https://files.wondercv.com/Game/character/boy/hari2/red/suit1.png")
          .add("user-preview-43", "https://files.wondercv.com/Game/character/boy/hari2/red/suit2.png")
          .add("user-preview-44", "https://files.wondercv.com/Game/character/boy/hari2/red/suit4.png")
          .add("user-preview-45", "https://files.wondercv.com/Game/character/boy/hari3/brown/suit1.png")
          .add("user-preview-46", "https://files.wondercv.com/Game/character/boy/hari3/brown/suit2.png")
          .add("user-preview-47", "https://files.wondercv.com/Game/character/boy/hari3/brown/suit4.png")
          .add("user-preview-48", "https://files.wondercv.com/Game/character/boy/hari3/gray/suit1.png")
          .add("user-preview-49", "https://files.wondercv.com/Game/character/boy/hari3/gray/suit2.png")
          .add("user-preview-50", "https://files.wondercv.com/Game/character/boy/hari3/gray/suit4.png")
          .add("user-preview-51", "https://files.wondercv.com/Game/character/boy/hari3/red/suit1.png")
          .add("user-preview-52", "https://files.wondercv.com/Game/character/boy/hari3/red/suit2.png")
          .add("user-preview-53", "https://files.wondercv.com/Game/character/boy/hari3/red/suit4.png")
          .add("dialog1", "https://files.wondercv.com/Game/character/H5/dialog1.png")
          .add("input_normal", "https://files.wondercv.com/Game/character/H5/input_normal.png")
          .add("input_select", "https://files.wondercv.com/Game/character/H5/input_select.png")
          .add("button_normal", "https://files.wondercv.com/Game/character/H5/button_normal.png")
          .add("button_press", "https://files.wondercv.com/Game/character/H5/button_press.png")
          .add("boy_hair1_brown_suit1", "https://files.wondercv.com/Game/character/move/boy_hair1_brown_suit1.png")
          .add("boy_hair1_brown_suit2", "https://files.wondercv.com/Game/character/move/boy_hair1_brown_suit2.png")
          .add("boy_hair1_brown_suit4", "https://files.wondercv.com/Game/character/move/boy_hair1_brown_suit4.png")
          .add("boy_hair1_gray_suit1", "https://files.wondercv.com/Game/character/move/boy_hair1_gray_suit1.png")
          .add("boy_hair1_gray_suit2", "https://files.wondercv.com/Game/character/move/boy_hair1_gray_suit2.png")
          .add("boy_hair1_gray_suit4", "https://files.wondercv.com/Game/character/move/boy_hair1_gray_suit4.png")
          .add("boy_hair1_red_suit1", "https://files.wondercv.com/Game/character/move/boy_hair1_red_suit1.png")
          .add("boy_hair1_red_suit2", "https://files.wondercv.com/Game/character/move/boy_hair1_red_suit2.png")
          .add("boy_hair1_red_suit4", "https://files.wondercv.com/Game/character/move/boy_hair1_red_suit4.png")
          .add("boy_hair2_brown_suit1", "https://files.wondercv.com/Game/character/move/boy_hair2_brown_suit1.png")
          .add("boy_hair2_brown_suit2", "https://files.wondercv.com/Game/character/move/boy_hair2_brown_suit2.png")
          .add("boy_hair2_brown_suit4", "https://files.wondercv.com/Game/character/move/boy_hair2_brown_suit4.png")
          .add("boy_hair2_gray_suit1", "https://files.wondercv.com/Game/character/move/boy_hair2_gray_suit1.png")
          .add("boy_hair2_gray_suit2", "https://files.wondercv.com/Game/character/move/boy_hair2_gray_suit2.png")
          .add("boy_hair2_gray_suit4", "https://files.wondercv.com/Game/character/move/boy_hair2_gray_suit4.png")
          .add("boy_hair2_red_suit1", "https://files.wondercv.com/Game/character/move/boy_hair2_red_suit1.png")
          .add("boy_hair2_red_suit2", "https://files.wondercv.com/Game/character/move/boy_hair2_red_suit2.png")
          .add("boy_hair2_red_suit4", "https://files.wondercv.com/Game/character/move/boy_hair2_red_suit4.png")
          .add("boy_hair3_brown_suit1", "https://files.wondercv.com/Game/character/move/boy_hair3_brown_suit1.png")
          .add("boy_hair3_brown_suit2", "https://files.wondercv.com/Game/character/move/boy_hair3_brown_suit2.png")
          .add("boy_hair3_brown_suit4", "https://files.wondercv.com/Game/character/move/boy_hair3_brown_suit4.png")
          .add("boy_hair3_gray_suit1", "https://files.wondercv.com/Game/character/move/boy_hair3_gray_suit1.png")
          .add("boy_hair3_gray_suit2", "https://files.wondercv.com/Game/character/move/boy_hair3_gray_suit2.png")
          .add("boy_hair3_gray_suit4", "https://files.wondercv.com/Game/character/move/boy_hair3_gray_suit4.png")
          .add("boy_hair3_red_suit1", "https://files.wondercv.com/Game/character/move/boy_hair3_red_suit1.png")
          .add("boy_hair3_red_suit2", "https://files.wondercv.com/Game/character/move/boy_hair3_red_suit2.png")
          .add("boy_hair3_red_suit4", "https://files.wondercv.com/Game/character/move/boy_hair3_red_suit4.png")
          .add("girl_hair1_brown_suit1", "https://files.wondercv.com/Game/character/move/girl_hair1_brown_suit1.png")
          .add("girl_hair1_brown_suit2", "https://files.wondercv.com/Game/character/move/girl_hair1_brown_suit2.png")
          .add("girl_hair1_brown_suit3", "https://files.wondercv.com/Game/character/move/girl_hair1_brown_suit3.png")
          .add("girl_hair1_gray_suit1", "https://files.wondercv.com/Game/character/move/girl_hair1_gray_suit1.png")
          .add("girl_hair1_gray_suit2", "https://files.wondercv.com/Game/character/move/girl_hair1_gray_suit2.png")
          .add("girl_hair1_gray_suit3", "https://files.wondercv.com/Game/character/move/girl_hair1_gray_suit3.png")
          .add("girl_hair1_red_suit1", "https://files.wondercv.com/Game/character/move/girl_hair1_red_suit1.png")
          .add("girl_hair1_red_suit2", "https://files.wondercv.com/Game/character/move/girl_hair1_red_suit2.png")
          .add("girl_hair1_red_suit3", "https://files.wondercv.com/Game/character/move/girl_hair1_red_suit3.png")
          .add("girl_hair2_brown_suit1", "https://files.wondercv.com/Game/character/move/girl_hair2_brown_suit1.png")
          .add("girl_hair2_brown_suit2", "https://files.wondercv.com/Game/character/move/girl_hair2_brown_suit2.png")
          .add("girl_hair2_brown_suit3", "https://files.wondercv.com/Game/character/move/girl_hair2_brown_suit3.png")
          .add("girl_hair2_gray_suit1", "https://files.wondercv.com/Game/character/move/girl_hair2_gray_suit1.png")
          .add("girl_hair2_gray_suit2", "https://files.wondercv.com/Game/character/move/girl_hair2_gray_suit2.png")
          .add("girl_hair2_gray_suit3", "https://files.wondercv.com/Game/character/move/girl_hair2_gray_suit3.png")
          .add("girl_hair2_red_suit1", "https://files.wondercv.com/Game/character/move/girl_hair2_red_suit1.png")
          .add("girl_hair2_red_suit2", "https://files.wondercv.com/Game/character/move/girl_hair2_red_suit2.png")
          .add("girl_hair2_red_suit3", "https://files.wondercv.com/Game/character/move/girl_hair2_red_suit3.png")
          .add("girl_hair3_brown_suit1", "https://files.wondercv.com/Game/character/move/girl_hair3_brown_suit1.png")
          .add("girl_hair3_brown_suit2", "https://files.wondercv.com/Game/character/move/girl_hair3_brown_suit2.png")
          .add("girl_hair3_brown_suit3", "https://files.wondercv.com/Game/character/move/girl_hair3_brown_suit3.png")
          .add("girl_hair3_gray_suit1", "https://files.wondercv.com/Game/character/move/girl_hair3_gray_suit1.png")
          .add("girl_hair3_gray_suit2", "https://files.wondercv.com/Game/character/move/girl_hair3_gray_suit2.png")
          .add("girl_hair3_gray_suit3", "https://files.wondercv.com/Game/character/move/girl_hair3_gray_suit3.png")
          .add("girl_hair3_red_suit1", "https://files.wondercv.com/Game/character/move/girl_hair3_red_suit1.png")
          .add("girl_hair3_red_suit2", "https://files.wondercv.com/Game/character/move/girl_hair3_red_suit2.png")
          .add("girl_hair3_red_suit3", "https://files.wondercv.com/Game/character/move/girl_hair3_red_suit3.png")
          .add("sign_in", "https://files.wondercv.com/Game/character/H5/bg1.png")
          .add("subscribe", "https://files.wondercv.com/Game/character/H5/bg2.png")
          .add("live", "https://files.wondercv.com/Game/character/H5/bg3.png")
          .load(this.setup);
          this.loader.onProgress.add((loader) => {
            this.progressNum = loader.progress
          });
      },
      //图片加载完函数
      setup(loader, resources){
        const app = this.spaceApp
        //创建一个容器
        const gameScene = new Container();
        this.gameScene = gameScene
        gameScene.width = 2100 * this.zoom
        gameScene.height = 1671* this.zoom
        let contentBox = document.querySelector(".stage-main")
        let {clientWidth, clientHeight} = contentBox
        gameScene.x = -(((989 + 32 + 145) * this.zoom - (clientWidth / 2)))
        gameScene.y = -((1671* this.zoom) - clientHeight)
        //画墙
        const topWall =  new Sprite(resources.upWall.texture);
        topWall.width = 2100 * this.zoom;
        topWall.height = 187 * this.zoom;
        topWall.x = 0
        this.crashItem.push(topWall)
        const leftWall =  new Sprite(resources.leftWall.texture);
        leftWall.width = 32 * this.zoom;
        leftWall.height = (1634 - 40) * this.zoom;
        leftWall.y = 19 * this.zoom
        this.crashItem.push(leftWall)
        const rightWall =  new Sprite(resources.leftWall.texture);
        rightWall.width = 32 * this.zoom;
        rightWall.height = (1634 - 40) * this.zoom;
        rightWall.y = 19 * this.zoom
        rightWall.x = (2100 - 32) * this.zoom
        this.crashItem.push(rightWall)
        const bottomWall =  new Sprite(resources.bottomWall.texture);
        bottomWall.width = 2100 * this.zoom;
        bottomWall.height = 20 * this.zoom;
        bottomWall.x = 0
        bottomWall.y = (1634 - 20) * this.zoom
        this.crashItem.push(bottomWall)
        //大厅地板
        const hallFloor = new Sprite(resources.hallFloor.texture);
        hallFloor.width = 1494 * this.zoom;
        hallFloor.height = 1620 * this.zoom;
        hallFloor.x = (32 + 543) * this.zoom
        hallFloor.y = 0
        gameScene.addChild(hallFloor);
        gameScene.addChild(topWall);
        gameScene.addChild(leftWall);
        gameScene.addChild(rightWall);
        //左一房间
        this.initFirstRoom(resources, gameScene)
        //左二房间
        this.initSecondRoom(resources, gameScene)
        //左三房间
        this.initThirdRoom(resources, gameScene)
        //大厅
        this.initHall(resources, gameScene)
        gameScene.addChild(bottomWall);
        app.stage.addChild(gameScene)
        if(this.hanUserInfo && this.userResources){
          this.initUser(resources, app.stage, this.userResources)
        }
        app.ticker.add(delta => this.gameLoop(delta));
      },
      //屏幕变化函数
      resizeGame(){
        if(!this.spaceApp) return;
        const {clientHeight, clientWidth} = document.body
        this.clientHeight = clientHeight
        this.clientWidth = clientWidth
        this.spaceApp.renderer.resize(Math.min(...[2100, clientWidth]),  Math.min(...[1671, clientHeight]))
      },
      //初始化第一个房间
      initFirstRoom(resources, gameScene){
        //地板
        const leftFirstFloor = new Sprite(resources.leftFirstFloor.texture)
        leftFirstFloor.width = 541 * this.zoom
        leftFirstFloor.height = 373 * this.zoom
        leftFirstFloor.x = 32 * this.zoom
        leftFirstFloor.y = 187 * this.zoom
        gameScene.addChild(leftFirstFloor);
        //挂画
        const leftFirstPicture =  new Sprite(resources.leftFirstPicture.texture);
        leftFirstPicture.width = 101 * this.zoom;
        leftFirstPicture.height = 50 * this.zoom;
        leftFirstPicture.x = (32 + 73) * this.zoom
        leftFirstPicture.y = 25 * this.zoom
        gameScene.addChild(leftFirstPicture);
        //柜子
        const leftFirstChest = new Sprite(resources.leftFirstChest.texture);
        leftFirstChest.width = 177 * this.zoom
        leftFirstChest.height = 110 * this.zoom
        leftFirstChest.x = (32 + 35) * this.zoom
        leftFirstChest.y = 82 * this.zoom
        gameScene.addChild(leftFirstChest);
        this.crashItem.push(leftFirstChest)
        //白板
        const leftFirstBoard = new Sprite(resources.leftFirstBoard.texture);
        leftFirstBoard.width = 92;
        leftFirstBoard.height = 74;
        leftFirstBoard.x = (32 + 247) * this.zoom
        leftFirstBoard.y = 52 * this.zoom
        gameScene.addChild(leftFirstBoard);
        this.crashItem.push(leftFirstBoard)
        //植物
        const leftFirstBotany = new Sprite(resources.leftFirstBotany.texture);
        leftFirstBotany.width = 54 * this.zoom;
        leftFirstBotany.height = 89 * this.zoom;
        leftFirstBotany.x = (32 + 453) * this.zoom
        leftFirstBotany.y = 122 * this.zoom
        gameScene.addChild(leftFirstBotany);
        this.crashItem.push(leftFirstBotany)
        //沙发
        const leftFirstSofa = new Sprite(resources.leftFirstSofa.texture);
        leftFirstSofa.width = 60 * this.zoom;
        leftFirstSofa.height = 160 * this.zoom;
        leftFirstSofa.x = (32 + 206) * this.zoom
        leftFirstSofa.y = (187 + 108) * this.zoom
        gameScene.addChild(leftFirstSofa);
        this.crashItem.push(leftFirstSofa)
        //外墙
        const leftFirstOutWall = new Sprite(resources.leftFirstOutWall.texture);
        leftFirstOutWall.width = 37;
        leftFirstOutWall.height = 182;
        leftFirstOutWall.x = (32 + 518) * this.zoom
        leftFirstOutWall.y = 19 * this.zoom
        gameScene.addChild(leftFirstOutWall);
        this.crashItem.push(leftFirstOutWall)
      },
      //初始化第二个房间
      initSecondRoom(resources, gameScene){
        //内墙
        const leftSecondInnerWall = new Sprite(resources.leftSecondInnerWall.texture);
        leftSecondInnerWall.width = 552 * this.zoom;
        leftSecondInnerWall.height = 187 * this.zoom;
        leftSecondInnerWall.x = 30 * this.zoom
        leftSecondInnerWall.y = (373 + 187) * this.zoom
        leftSecondInnerWall.zIndex = 1
        gameScene.addChild(leftSecondInnerWall);
        this.crashItem.push(leftSecondInnerWall)
        //荧幕
        const leftSecondScreen = new Sprite(resources.leftSecondScreen.texture);
        leftSecondScreen.width = 140;
        leftSecondScreen.height = 75;
        leftSecondScreen.x = (32 + 50) * this.zoom
        leftSecondScreen.y = (408 + 187) * this.zoom
        gameScene.addChild(leftSecondScreen);
        //地板
        const leftSecondFloor = new Sprite(resources.leftSecondFloor.texture);
        leftSecondFloor.width = 541 * this.zoom;
        leftSecondFloor.height = 391 * this.zoom;
        leftSecondFloor.x = 32 * this.zoom;
        leftSecondFloor.y = (560 + 187) * this.zoom
        gameScene.addChild(leftSecondFloor);
        //外墙
        const leftSecondOutWall = new Sprite(resources.leftSecondOutWall.texture);
        leftSecondOutWall.width = 37;
        leftSecondOutWall.height = 252;
        leftSecondOutWall.x = (32 + 518) * this.zoom;
        leftSecondOutWall.y = (271 + 187) * this.zoom
        gameScene.addChild(leftSecondOutWall);
        this.crashItem.push(leftSecondOutWall)
        //电视
        const leftSecondOutTv = new Sprite(resources.leftSecondOutTv.texture);
        leftSecondOutTv.width = 128 * this.zoom;
        leftSecondOutTv.height = 119 * this.zoom;
        leftSecondOutTv.x = (350 + 32) * this.zoom;
        leftSecondOutTv.y = (472 + 187) * this.zoom;
        gameScene.addChild(leftSecondOutTv);
        this.crashItem.push(leftSecondOutTv)
        //桌子
        const leftSecondSofa = new Sprite(resources.leftSecondSofa.texture);
        leftSecondSofa.width = 60 * this.zoom;
        leftSecondSofa.height = 160 * this.zoom;
        leftSecondSofa.x = (32 + 209) * this.zoom
        leftSecondSofa.y = (659 + 206) * this.zoom
        gameScene.addChild(leftSecondSofa);
        this.crashItem.push(leftSecondSofa);
      },
      //初始化第三个房间
      initThirdRoom(resources, gameScene){
        //内墙
        const leftThirdInnerWall = new Sprite(resources.leftThirdInnerWall.texture);
        leftThirdInnerWall.width = 522 * this.zoom;
        leftThirdInnerWall.height = 188 * this.zoom;
        leftThirdInnerWall.x = 32 * this.zoom
        leftThirdInnerWall.y = (951 + 187) * this.zoom
        gameScene.addChild(leftThirdInnerWall);
        this.crashItem.push(leftThirdInnerWall)
        //壁画
        const leftThirdPic = new Sprite(resources.leftThirdPic.texture);
        leftThirdPic.width = 140;
        leftThirdPic.height = 75;
        leftThirdPic.x = (32 + 131) * this.zoom
        leftThirdPic.y = (987 + 187) * this.zoom
        gameScene.addChild(leftThirdPic);
        //音响1
        const leftThirdSound1 = new Sprite(resources.leftThirdSound.texture);
        leftThirdSound1.width = 28 * this.zoom;
        leftThirdSound1.height = 44 * this.zoom;
        leftThirdSound1.x = (32 + 82) * this.zoom
        leftThirdSound1.y = (1004 + 187) * this.zoom
        gameScene.addChild(leftThirdSound1);
        //音响2
        const leftThirdSound2 = new Sprite(resources.leftThirdSound.texture);
        leftThirdSound2.width = 28 * this.zoom;
        leftThirdSound2.height = 44 * this.zoom;
        leftThirdSound2.x = (32 + 411) * this.zoom
        leftThirdSound2.y = (1004 + 187) * this.zoom
        gameScene.addChild(leftThirdSound2);
        //音响3
        const leftThirdSound3 = new Sprite(resources.leftThirdSound.texture);
        leftThirdSound3.width = 28 * this.zoom;
        leftThirdSound3.height = 44 * this.zoom;
        leftThirdSound3.x = (32 + 82) * this.zoom
        leftThirdSound3.y = (1062 + 187) * this.zoom
        gameScene.addChild(leftThirdSound3);
        //音响4
        const leftThirdSound4 = new Sprite(resources.leftThirdSound.texture);
        leftThirdSound4.width = 28 * this.zoom;
        leftThirdSound4.height = 44 * this.zoom;
        leftThirdSound4.x = (32 + 411) * this.zoom
        leftThirdSound4.y = (1062 + 187) * this.zoom
        gameScene.addChild(leftThirdSound4);
        //地板
        const leftThirdFloor = new Sprite(resources.leftThirdFloor.texture);
        leftThirdFloor.width = 541 * this.zoom;
        leftThirdFloor.height = 295 * this.zoom;
        leftThirdFloor.x = 32 * this.zoom
        leftThirdFloor.y = (1140 + 187) * this.zoom
        gameScene.addChild(leftThirdFloor);
        //讲台
        const leftThirdPlatform = new Sprite(resources.leftThirdPlatform.texture);
        leftThirdPlatform.width = 518 * this.zoom;
        leftThirdPlatform.height = 105 * this.zoom;
        leftThirdPlatform.x = 32 * this.zoom
        leftThirdPlatform.y = (1139 + 187) * this.zoom
        gameScene.addChild(leftThirdPlatform);
        //植物
        const leftThirdBotany = new Sprite(resources.leftThirdBotany.texture);
        leftThirdBotany.width = 54 * this.zoom;
        leftThirdBotany.height = 89 * this.zoom;
        leftThirdBotany.x = (32 + 14) * this.zoom
        leftThirdBotany.y = (1070 + 187 )* this.zoom
        gameScene.addChild(leftThirdBotany);
        this.crashItem.push(leftThirdBotany)
        //椅子
        // const leftThirdChair = new Sprite(resources.leftThirdChair.texture);
        // leftThirdChair.width = 288 * this.zoom;
        // leftThirdChair.height = 71 * this.zoom;
        // leftThirdChair.x = (32 + 115) * this.zoom
        // leftThirdChair.y = (1312 + 187) * this.zoom
        // gameScene.addChild(leftThirdChair);
        // this.crashItem.push(leftThirdChair)
        //外墙1
        const leftThirdOutWallOne = new Sprite(resources.leftThirdOutWallOne.texture);
        leftThirdOutWallOne.width = 37;
        leftThirdOutWallOne.height = 242;
        leftThirdOutWallOne.x = (518 + 32) * this.zoom;
        leftThirdOutWallOne.y = (826 + 187) * this.zoom;
        gameScene.addChild(leftThirdOutWallOne);
        this.crashItem.push(leftThirdOutWallOne)
        //外墙2
        const leftThirdOutWallTwo = new Sprite(resources.leftThirdOutWallTwo.texture);
        leftThirdOutWallTwo.width = 32 * this.zoom;
        leftThirdOutWallTwo.height = 86 * this.zoom;
        leftThirdOutWallTwo.x = (518 + 32) * this.zoom;
        leftThirdOutWallTwo.y = (1345 + 187)* this.zoom;
        gameScene.addChild(leftThirdOutWallTwo);
        this.crashItem.push(leftThirdOutWallTwo)
      },
      //初始化大厅
      initHall(resources, gameScene){
        //b站模型
        const hallModel = new Sprite(resources.hallModel.texture);
        hallModel.width = 108;
        hallModel.height = 110;
        hallModel.x = (588 + 32) * this.zoom;
        hallModel.y = 78 * this.zoom;
        gameScene.addChild(hallModel);
        this.crashItem.push(hallModel)
        //荧幕
        const hallScreen = new Sprite(resources.hallScreen.texture);
        hallScreen.width = 268;
        hallScreen.height = 81;
        hallScreen.x = (887 + 32) * this.zoom;
        hallScreen.y = 29 * this.zoom;
        hallScreen.interactive = true
        hallScreen.buttonMode = true;
        hallScreen.InitHeight = 5;
        this.live_Box = hallScreen
        hallScreen.on("click", () => {
          // console.log(1)
        })
        gameScene.addChild(hallScreen);
        //音响
        const hallSound1 = new Sprite(resources.leftThirdSound.texture);
        hallSound1.width = 28 * this.zoom;
        hallSound1.height = 44 * this.zoom;
        hallSound1.x = (821 + 32) * this.zoom;
        hallSound1.y = 52 * this.zoom;
        gameScene.addChild(hallSound1);
        const hallSound2 = new Sprite(resources.leftThirdSound.texture);
        hallSound2.width = 28 * this.zoom;
        hallSound2.height = 44 * this.zoom;
        hallSound2.x = (821 + 32) * this.zoom;
        hallSound2.y = 110 * this.zoom;
        gameScene.addChild(hallSound2);
        const hallSound3 = new Sprite(resources.leftThirdSound.texture);
        hallSound3.width = 28 * this.zoom;
        hallSound3.height = 44 * this.zoom;
        hallSound3.x = (1413 + 32) * this.zoom;
        hallSound3.y = 52 * this.zoom;
        gameScene.addChild(hallSound3);
        //音响
        const hallSound4 = new Sprite(resources.leftThirdSound.texture);
        hallSound4.width = 28 * this.zoom;
        hallSound4.height = 44 * this.zoom;
        hallSound4.x = (1413 + 32) * this.zoom;
        hallSound4.y = 110 * this.zoom;
        gameScene.addChild(hallSound4);
        //讲台
        const hallPlatform = new Sprite(resources.hallPlatform.texture);
        hallPlatform.width = 547 * this.zoom;
        hallPlatform.height = 86 * this.zoom;
        hallPlatform.x = (858 + 32) * this.zoom;
        hallPlatform.y = 185 * this.zoom;
        gameScene.addChild(hallPlatform);
        //投递处
        const hallDeliver = new Sprite(resources.hallDeliver.texture);
        hallDeliver.width = 135;
        hallDeliver.height = 74;
        hallDeliver.x = (1497 + 32) * this.zoom;
        hallDeliver.y = 99 * this.zoom;
        gameScene.addChild(hallDeliver);
        this.crashItem.push(hallDeliver);
        //书架
        const hallBookRack = new Sprite(resources.hallBookRack.texture);
        hallBookRack.width = 187 * this.zoom;
        hallBookRack.height = 123 * this.zoom;
        hallBookRack.x = (1741 + 32) * this.zoom;
        hallBookRack.y = 111 * this.zoom;
        gameScene.addChild(hallBookRack);
        this.crashItem.push(hallBookRack);
        //植物
        const hallBotanyOne = new Sprite(resources.leftThirdBotany.texture);
        hallBotanyOne.width = 54 * this.zoom;
        hallBotanyOne.height = 89 * this.zoom;
        hallBotanyOne.x = (1958 + 21) * this.zoom;
        hallBotanyOne.y = 131 * this.zoom;
        gameScene.addChild(hallBotanyOne);
        this.crashItem.push(hallBotanyOne);
        //窗户
        const hallWindow = new Sprite(resources.hallWindow.texture);
        hallWindow.width = 122 * this.zoom;
        hallWindow.height = 45 * this.zoom;
        hallWindow.x = (1774 + 32) * this.zoom;
        hallWindow.y = 44 * this.zoom;
        gameScene.addChild(hallWindow);
        //右上椅子
        const hallChair = new Sprite(resources.hallChair.texture);
        hallChair.width = 238 * this.zoom;
        hallChair.height = 95 * this.zoom;
        hallChair.x = (1667 + 32) * this.zoom;
        hallChair.y = (129 + 207) * this.zoom;
        gameScene.addChild(hallChair);
        this.crashItem.push(hallChair);
        //墙
        const hallInnerWall = new Sprite(resources.hallInnerWall.texture);
        hallInnerWall.width = 275;
        hallInnerWall.height = 103;
        hallInnerWall.x = (1539 + 32) * this.zoom;
        hallInnerWall.y = (418 + 187) * this.zoom;
        gameScene.addChild(hallInnerWall);
        this.crashItem.push(hallInnerWall);
        //冰箱
        const hallRefrigerator = new Sprite(resources.hallRefrigerator.texture);
        hallRefrigerator.width = 295 * this.zoom;
        hallRefrigerator.height = 132 * this.zoom;
        hallRefrigerator.x = (1735 + 32) * this.zoom;
        hallRefrigerator.y = (504 + 187) * this.zoom;
        gameScene.addChild(hallRefrigerator);
        this.crashItem.push(hallRefrigerator);
        //沙发1
        const hallSofa1 = new Sprite(resources.hallSofa.texture);
        hallSofa1.width = 60 * this.zoom;
        hallSofa1.height = 160 * this.zoom;
        hallSofa1.x = (1691 + 102) * this.zoom;
        hallSofa1.y = (933 + 140) * this.zoom;
        gameScene.addChild(hallSofa1);
        this.crashItem.push(hallSofa1);
        //沙发2
        const hallSofa2 = new Sprite(resources.hallSofa.texture);
        hallSofa2.width = 60 * this.zoom;
        hallSofa2.height = 160 * this.zoom;
        hallSofa2.x = (1691 + 102) * this.zoom;
        hallSofa2.y = (1186 + 140) * this.zoom;
        gameScene.addChild(hallSofa2);
        this.crashItem.push(hallSofa2);
        //入口墙
        const hallJoinWall = new Sprite(resources.hallJoinWall.texture);
        hallJoinWall.width = 275;
        hallJoinWall.height = 103;
        hallJoinWall.x = (915 + 32) * this.zoom;
        hallJoinWall.y = (748 + 187) * this.zoom;
        gameScene.addChild(hallJoinWall);
        this.crashItem.push(hallJoinWall);
        //入口植物1
        const hallJoinBotany1 = new Sprite(resources.leftThirdBotany.texture);
        hallJoinBotany1.width = 54 * this.zoom;
        hallJoinBotany1.height = 89 * this.zoom;
        hallJoinBotany1.x = (891 + 32) * this.zoom;
        hallJoinBotany1.y = (855 + 187) * this.zoom;
        gameScene.addChild(hallJoinBotany1);
        this.crashItem.push(hallJoinBotany1);
        //入口植物2
        const hallJoinBotany2 = new Sprite(resources.leftThirdBotany.texture);
        hallJoinBotany2.width = 54 * this.zoom;
        hallJoinBotany2.height = 89 * this.zoom;
        hallJoinBotany2.x = (1384 + 32) * this.zoom;
        hallJoinBotany2.y = (855 + 187) * this.zoom;
        gameScene.addChild(hallJoinBotany2);
        this.crashItem.push(hallJoinBotany2);
        //饮水机
        const hallDispenser = new Sprite(resources.hallDispenser.texture);
        hallDispenser.width = 35 * this.zoom;
        hallDispenser.height = 133 * this.zoom;
        hallDispenser.x = (945 + 32) * this.zoom;
        hallDispenser.y = (894 + 187) * this.zoom;
        gameScene.addChild(hallDispenser);
        this.crashItem.push(hallDispenser);
        //前台
        const hallReception = new Sprite(resources.hallReception.texture);
        hallReception.width = 373 * this.zoom;
        hallReception.height = 134 * this.zoom;
        hallReception.x = (978 + 32) * this.zoom;
        hallReception.y = (887 + 187) * this.zoom;
        gameScene.addChild(hallReception);
        this.crashItem.push(hallReception);
        //签到牌
        const hallCard = new Sprite(resources.hallCard.texture);
        hallCard.width = 40;
        hallCard.height = 20;
        hallCard.x = (1249 + 32) * this.zoom;
        hallCard.y = (918 + 187) * this.zoom;
        gameScene.addChild(hallCard);
        this.crashItem.push(hallCard);
        //地毯
        const hallCarpet =  new Sprite(resources.hallCarpet.texture);
        hallCarpet.width = 290 * this.zoom;
        hallCarpet.height = 102 * this.zoom;
        hallCarpet.x = (1019 + 32) * this.zoom;
        hallCarpet.y = (1039 + 187) * this.zoom;
        gameScene.addChild(hallCarpet);
        //中心椅子1
        const hallCenterChair1 = new Sprite(resources.hallCenterChair1.texture);
        hallCenterChair1.width = 88 * this.zoom;
        hallCenterChair1.height = 79 * this.zoom;
        hallCenterChair1.x = (1070 + 54) * this.zoom;
        hallCenterChair1.y = (349 + 145) * this.zoom;
        gameScene.addChild(hallCenterChair1);
        this.crashItem.push(hallCenterChair1);
        //中心椅子2
        const hallCenterChair2 = new Sprite(resources.hallCenterChair2.texture);
        hallCenterChair2.width = 88 * this.zoom;
        hallCenterChair2.height = 79 * this.zoom;
        hallCenterChair2.x = (915 + 42) * this.zoom;
        hallCenterChair2.y = (513 + 162) * this.zoom;
        gameScene.addChild(hallCenterChair2);
        this.crashItem.push(hallCenterChair2);
        //中心椅子3
        const hallCenterChair3 = new Sprite(resources.hallCenterChair3.texture);
        hallCenterChair3.width = 88 * this.zoom;
        hallCenterChair3.height = 79 * this.zoom;
        hallCenterChair3.x = (1225 + 68) * this.zoom;
        hallCenterChair3.y = (513 + 162) * this.zoom;
        gameScene.addChild(hallCenterChair3);
        this.crashItem.push(hallCenterChair3);
        //欢迎
        const welcome = new Sprite(resources.welcome.texture);
        welcome.width = 649 * this.zoom;
        welcome.height = 150 * this.zoom;
        welcome.x = (811 + 32) * this.zoom;
        welcome.y = (1205 + 187) * this.zoom;
        gameScene.addChild(welcome);
        //zhuoyi7
        const zhuoyi7 = new Sprite(resources.zhuoyi7.texture);
        zhuoyi7.width = 285 * this.zoom;
        zhuoyi7.height = 123 * this.zoom;
        zhuoyi7.x = (1655 + 32) * this.zoom;
        zhuoyi7.y = (702 + 187) * this.zoom;
        gameScene.addChild(zhuoyi7);
        this.crashItem.push(zhuoyi7);
        //Rectangle
        let rectangle = new Graphics();
        rectangle.beginFill(0x66CCFF, 0);
        rectangle.drawRect(0, 0, 73 * this.zoom, 35 * this.zoom);
        rectangle.endFill();
        rectangle.x = (1249 + 32) * this.zoom;
        rectangle.y = (918 + 187 + 70) * this.zoom;
        this.sign_in = rectangle
        gameScene.addChild(rectangle);
      },
      //初始化用户
      initUser(resources, parentView, userResources){
        let x,y
        if(parentView.children.some(item => item.name === 'user')){
          let index = parentView.children.findIndex(item => item.name === 'user')
          x = this.user.x
          y = this.user.y
          parentView.removeChildAt(index)
          this.user = null
        }
        let contentBox = document.querySelector(".stage-main")
        let {clientWidth, clientHeight} = contentBox
        let positionX = x || (clientWidth / 2)
        let positionY = y || (clientHeight - 150)
        //初始化图片
        const option = {
        startX: 0,//起点x坐标
        startY: 0,//起点y坐标
        width: 210,//一个图片的宽度
        height: 300,//一个图片的高度
        alone: false,//是否单个。。为false就是动画的雪碧图需要返回一个AnimatedSprite对象
        positionX,//定位到父级的X
        positionY,//定位到父级的Y
        crashValue:  (60 / 210) * 300 * this.zoom,
        loopOption: { //循环动画配置参数
          row: 8, //一个多少行
          col: 1, //多少列
          total: 8,//多少张图片
          initFrame: 1, //初始帧
          isStart: true,//是否默认开启动画
          initSpeed: 0.07//动画循环速度
        },
      }
        this.user = spriteForImageOrAnimatedSprite(userResources, option);
        this.user.scale.set(60 / 148 * this.zoom)
        this.user.up = true;
        this.user.down = true;
        this.user.left = true;
        this.user.right = true;
        this.user.sortableChildren = true
        this.user.zIndex = 0
        this.user.animateDirection = "down";
        this.user.name = "user"
        parentView.addChild(this.user)
        //初始化键位
        let left = keyboard(37),
          up = keyboard(38),
          right = keyboard(39),
          down = keyboard(40);
        //Left arrow key `press` method
        left.press = () => {
          this.user.gotoAndPlay(2)
          this.user.vx = -5;
          this.user.vy = 0;
          this.user.animateDirection = "left"
        };
        //Left arrow key `release` method
        left.release = () =>  {
          if (!right.isDown && this.user.vy === 0) {
            this.user.gotoAndStop(2)
            this.user.vx = 0;
            this.user.animateDirection = null
          }
        };
        //Up
        up.press =  () => {
          this.user.gotoAndStop(0)
          this.user.vx = 0;
          this.user.vy = -5;
          this.user.animateDirection = "up"
        };
        up.release = () => {
          if (!down.isDown && this.user.vx === 0) {
            // this.user.gotoAndStop(0)
            this.user.vy = 0;
            this.user.animateDirection = null
          }
        };
        //Right
        right.press = () => {
          this.user.gotoAndPlay(5);
          this.user.vx = 5;
          this.user.vy = 0;
          this.user.animateDirection = "right"
        };
        right.release = () => {
          if (!left.isDown && this.user.vy === 0) {
            this.user.gotoAndStop(5)
            this.user.vx = 0;
            this.user.animateDirection = null
          }
        };
        //Down
        down.press = () => {
          this.user.gotoAndStop(1)
          this.user.vx = 0;
          this.user.vy = 5;
          this.user.animateDirection = "down"
        };
        down.release = () => {
          if (!up.isDown && this.user.vx === 0) {
            this.user.gotoAndStop(1)
            this.user.vy = 0;
            this.user.animateDirection = null
          }
        };
      },
      gameLoop(){
        if(!this.user)return;
        // if(hitTestRectangle(this.user,this.live_Box)){
        //   if(this.isShowLiveBox)return;
        //   this.isShowLiveBox = true
        //   return;
        // }
        // if(hitTestRectangle(this.user,this.sign_in) && !this.isSignIn && (!this.isSubscribeLive && this.isShowSubscribeLive)){
        //   if(this.isShowSignBox)return;
        //   this.isShowSignBox = true
        //   return;
        // }
        this.changeImage(this.user);
        let dom = hitTestRectangleByList(this.user, this.crashItem)
        direction(this.user, dom)
        this.gameSceneTransform();
      },
      // 人物移动
      gameSceneTransform(){
        let screenWidth = 343;
        let screenHeight = 462;
        let outWidth = this.canvasWidth - screenWidth;
        let outHeight = this.canvasHeight - screenHeight;
        if(this.user.vx > 0){
          if( screenWidth < this.canvasWidth ){
          // 右移
          if(this.user.x >= parseInt(screenWidth / 2) && Math.abs(this.gameScene.x) < outWidth ){
              this.gameScene.x -= this.user.right ? this.user.vx : 0
            }else {
              this.user.x += this.user.right ? this.user.vx : 0
            }
          }else {
            // 展示区width大于内容区
            this.user.x += this.user.right ? this.user.vx : 0
          }
        } else if(this.user.vx < 0){
          if( screenWidth < this.canvasWidth ){
            // 左移
            if(this.user.x <= parseInt(screenWidth / 2 - 73) && this.gameScene.x < 0){
              this.gameScene.x -= this.user.left ? this.user.vx : 0
            }else {
              this.user.x += this.user.left ? this.user.vx : 0
            }
          }else {
            // 展示区width大于内容区
            this.user.x += this.user.left ? this.user.vx : 0
          }
        }
        if(this.user.vy > 0){
          if(screenHeight < this.canvasHeight){
            // 下移
            if(this.user.y >= (parseInt(screenHeight / 2) - 75) && Math.abs(this.gameScene.y) < outHeight){
              this.gameScene.y -= this.user.down ? this.user.vy : 0
            }else {
              this.user.y += this.user.down ? this.user.vy : 0
            }
          }else {
            this.user.y += this.user.down ? this.user.vy : 0
          }
        } else if(this.user.vy < 0){
          if(screenHeight < this.canvasHeight){
            // 上移
            if(this.user.y <= parseInt(screenHeight / 2 - 75) && this.gameScene.y < 0){
              this.gameScene.y -= this.user.up ? this.user.vy : 0
            }else {
              this.user.y += this.user.up ? this.user.vy : 0
            }
          }else {
            this.user.y += this.user.up ? this.user.vy : 0
          }
        }
        // 签到位置判断
        let gameSceneX = Math.abs(this.gameScene.x);
        let gameSceneY = Math.abs(this.gameScene.y);
        if(this.user.x + gameSceneX >= 516 && this.user.x + gameSceneX <= 756 && this.user.y + gameSceneY >= 610 && this.user.y  + gameSceneY <= 660 && !this.isSignIn && !this.isSubscribeLive && this.isShowSubscribeLive){
          if(!this.isShowSignBox && !this.isCloseSignIn){
            this.isShowSignBox = true;
          }
        }else {
          this.isCloseSignIn = false;
          this.isShowSignBox = false;
        }
        // 直播弹窗
        if(((this.user.x + gameSceneX >= 451 && this.user.x + gameSceneX <= 756) || (this.user.x + gameSceneX >= 791 && this.user.x + gameSceneX <= 961)) && this.user.y + gameSceneY >= 64 && this.user.y  + gameSceneY <= 144){
          this.showMaskUrlType = 1;
          if(!this.isShowLiveBox && !this.isCloseLive){
            console.log("直播弹窗")
            this.isShowLiveBox  = true;
            return ;
          }
        }else if(this.user.x + gameSceneX >= 21 && this.user.x + gameSceneX <= 251 && this.user.y + gameSceneY >= 684 && this.user.y  + gameSceneY <= 1350){
          // 广告弹窗 （左下） 
          this.bannerUrl = "https://files.wondercv.com/Game/banner2.png";
          if(!this.showBanner && !this.isCloseLive){
            console.log("左下")
            this.showBanner = true;
          }
        } else if(this.user.x + gameSceneX >= 21 && this.user.x + gameSceneX <= 171 && this.user.y + gameSceneY >= 369 && this.user.y  + gameSceneY <= 394){
          // 广告弹窗 （左中）
          this.bannerUrl = "https://files.wondercv.com/Game/banner1.png";
          if(!this.showBanner && !this.isCloseLive){
            console.log('左中')
            this.showBanner = true;
          }
        } else if(this.user.x + gameSceneX >= 820 && this.user.x + gameSceneX <= 966 && this.user.y + gameSceneY >= 394 && this.user.y  + gameSceneY <= 419){
          // 广告弹窗 （右中）
           this.bannerUrl = "https://files.wondercv.com/Game/banner3.png";
          if(!this.showBanner && !this.isCloseLive){
            console.log("右中")
            this.showBanner = true;
          }
        } else if(this.user.x + gameSceneX >= 116 && this.user.x + gameSceneX <= 251 && this.user.y + gameSceneY >= 64 && this.user.y  + gameSceneY <= 100){
          // 广告弹窗 （左上）
          this.showMaskUrlType = 3;
          if(!this.isShowLiveBox && !this.isCloseLive){
            console.log('左上')
            this.isShowLiveBox  = true;
          }
        } else {
          this.isCloseLive = false;
          this.isShowLiveBox  = false;
          this.showBanner = false;
        }
      },
      changeImage(spriteObject) {
        let index = spriteObject.currentFrame;
        if(this.user.animateDirection == "up"){
            if (index === 0) {
            spriteObject.gotoAndStop(0)
          }
        }else if(this.user.animateDirection == "down"){
          if (index === 1) {
            spriteObject.gotoAndStop(1)
          }
        }else if(this.user.animateDirection == "left"){
            if (index === 4) {
            spriteObject.gotoAndPlay(2)
          }
        }else if(this.user.animateDirection == "right"){
          if (index === 7) {
            spriteObject.gotoAndPlay(5)
          }
        }
      },
      // 提交人物形象
      submitVirtualization(userInfo){
        let { hair_style, hair_color, gender, suit, username } = userInfo;
        this.userInfo = userInfo
        let params = { hair_style, hair_color, gender, suit, username };
        api.space.postVirtualization(params).then(res => {
          if(res.code == 1000){
            this.createUser(res.data)
            this.initUser(this.loader.resources, this.spaceApp.stage, this.userResources)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 获取人物形象
      async getVirtualization(){
        let res = await api.space.getVirtualization()
        if(res.code == 1000){
          let { hair_style = 0, hair_color = 0, gender = 0, suit = 0, username } = res.data;
          if(!gender && !hair_style && !hair_color && !suit && !username){
            this.hanUserInfo = false
          }else {
            this.createUser(res.data)
          }
        }
      },
      //创建用户形象
      createUser({ hair_style = 0, hair_color = 0, gender = 0, suit = 0, username }){
        this.hanUserInfo = true
        this.step = 2
        const NumToColor = {
          0: "brown",
          1: "gray",
          2: "red"
        }
        hair_style = hair_style || 0
        hair_color = hair_color || 0
        gender = gender || 0
        suit = suit || 0
        username = username || ""
        const suitFormat = {
          "00": 1,
          "01": 2,
          "02": 4,
          "10": 1,
          "11": 2,
          "12": 3,
        }
        this.userInfo = {hair_style, hair_color, gender, suit, username}
        this.userResources = `${gender == 0 ? 'boy' : 'girl'}_hair${hair_style + 1}_${NumToColor[hair_color]}_suit${suitFormat[gender + '' + suit]}`
      },
      //键位
      handleClickKeyboard({type, keyType}){
        //按下
        if(keyType === 'down'){
          if(!this.user)return
          //人物移动操作
          if(keyboardVx[type] !== undefined && keyboardVy[type] !== undefined ){
            this.user.vx = keyboardVx[type]
            this.user.vy = keyboardVy[type]
            this.user.animateDirection = type
            keyboardAnimateStart[type](this)
          }
        }else if(keyType === 'up'){
          if(type === 'confirm' && this.step === 0){
            this.step = 1
          }else if(type === 'confirm' && this.step === 1){
            this.handle
          }
          //抬起
          if(!this.user)return
          if(keyboardVx[type] !== undefined && keyboardVy[type] !== undefined ) {
            this.user.vx = 0
            this.user.vy = 0
            this.user.animateDirection = null
            keyboardAnimateStop[type](this)
          }
        }
      },
      //选择身份
      handleChangeUserInfo(user){
        this.userInfo = JSON.parse(JSON.stringify({
          ...this.userInfo,
          ...user
        }))
      },
      //重新选择
      handleClickSetting(){
        this.step = 0;
        this.hanUserInfo = false
      },
      //获取直播ID和签到(预约)状态
      initData(){
        this.$api.space.getLivePlayId().then(res=>{
          if(res.code === 1000){
            this.liveToken = res.data || ""
            let originUrl = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com' : 'https://www.wondercv.cn';
            this.iframeUrl = originUrl + "/live/" + res.data;
            if((moment(res.data.start_at).unix()) > moment().unix()){
              this.isShowSubscribeLive = true
              return this.$api.space.isSubscribeLive({live_tokens: res.data})
            }
          }
        }).then(res => {
          if(res && res.code === 1000){
            if(res.data.length > 0){
              this.isSubscribeLive = true;
            }
          }
        })
        this.$api.space.getSignInStatus(1).then(res =>{
          if(res.code === 1000){
            this.isSignIn = res.data || false
          }
        })
      },
      close(){
        this.isShowSignBox = false
        this.isShowLiveBox = false
        this.isCloseLive = true;
        this.user.y = this.user.y + 10
      },
      //签到预约
      handleClickSignIn(isShowSubscribeLive){
        if(isShowSubscribeLive){
          this.$api.space.liveAddAppoint(this.liveToken).then(res=>{
            if(res.code === 1000){
              this.isSubscribeLive = true
              this.close()
            }else {
              console.log(res.message)
            }
          })
        }else {
          this.$api.space.postSignInStatus(1).then(res=>{
            if(res.code === 1000){
              this.isSignIn = true;
              this.close()
            }else {
              console.log(res.message)
            }
          })
        }
      },
      handleClickToDetail(){
        if(this.showMaskUrlType == 1){
          window.location.href = this.iframeUrl;
        }else {
          window.location.href = "https://docs.qq.com/doc/DUlRjTmRWY3RPWnFZ";
        }
      },
      // 获取简历列表
      getCvList(){
        this.$api.space.getCvList({page_size: 20, page: 1}).then(res => {
          if(res.code == 1000){
            this.cvList =  res.data.cvs;
          }else {
            console.log(res.message)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      timeFormatFilter(value){
        let today = moment().format('YYYYMMDD')
        let update = moment(value).format('YYYYMMDD')
        let year = moment().year()
        let updateYear = moment(value).year()
        if (today === update) {
          return moment(value).format('HH:mm')
        } else if (update - 0 === today - 1) {
          return '昨天'
        } else if (update < today - 1 && year === updateYear) {
          return moment(value).format('MM月DD日')
        } else if (updateYear < year) {
          return moment(value).format('YYYY年MM月DD日')
        }
      },
      // 简历详情
      toCvEditor(token){
        let target = document.createElement("a");
        target.setAttribute('href', window.location.origin + `/cvs/${token}/editor`)
        target.setAttribute('target', "_blank")
        target.click()
      },
      bannerToLink(type){
        window.location.href = "https://m.wondercv.com/activity/fuhuoOffer.com";
      }
    }
  }
</script>

<style scoped lang="scss">
  #page{
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .mask {
      position: absolute;
      left: 0px;
      right: 0px;
      top: 0px;
      bottom: 0px;
      background: #000;
      opacity: 0.7;
      z-index: 13;
    }
    .background-content{
      width: 363px;
      height: 715px;
      background-image: url("https://files.wondercv.com/Game/H5/stucture.png");
      background-repeat: no-repeat;
      background-size: 100%;
      padding: 41px 10px;
      .stage-main{
        width: 343px;
        height: 462px;
        overflow: hidden;
        border-radius: 6px;
        position: relative;
        .space-content{
          width: 100%;
          height: 100%;
          position: relative;
          z-index: 1;
        }
        .layer{
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background: #000;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          padding: 0 24px;
          p{
            margin-bottom: 20px;
          }
          .border{
            width: 100%;
            height: 20px;
            padding: 2px;
            border: 1px solid #fff;
            border-radius: 10px;
            .progress{
              height: 100%;
              border-radius: 10px;
              background-color: #fff;
            }
          }
        }
        .setting-btn{
          width: 30px;
          height: 30px;
          background: url("https://files.wondercv.com/Game/character/setting_default.png")  no-repeat 0px 0px ;
          background-size: 100% 100%;
          position: absolute;
          right: 10px;
          top: 10px;
          z-index: 10;
        }
      }
      .keyword-box{
        padding-top: 49px;
      }
    }
    .sign-in-box{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      .iconGroup11{
        position: absolute;
        font-size: 20px;
        top: 30%;
        right: 25px;
        color: #fff;
      }
      .sign-in{
        width: 320px;
        height: 450px;
        background-image: url("https://files.wondercv.com/Game/character/H5/bg1.png");
        background-size: 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 43px;
        .sign-in-btn{
          width: 250px;
          height: 50px;
          background-color: transparent;
        }
        &.subscribe{
          background-image: url("https://files.wondercv.com/Game/character/H5/bg2.png");
        }
      }
      .live-box{
        width: 320px;
        height: 284px;
        background-image: url("https://files.wondercv.com/Game/character/H5/bg3.png");
        background-size: 100%;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding-top: 30px;
        img{
          width: 278px;
          height: 155px;
          margin: 0 auto;
        }
      }
    }
    .banner-in-box {
      width: 320px;
      height: 258px;
      background: url("https://files.wondercv.com/Game/H5/more/bg.png") no-repeat 0px 0px;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 14;
      .banner-in-box-img {
        width: 290px;
        height: 134px;
        position: absolute;
        top: 12px;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .iconGroup11 {
        position: absolute;
        right: 0px;
        top: -28px;
        color: #fff;
      }
    }
    .view-cv{
    width: 30px;
    height: 30px;
    background: url("https://files.wondercv.com/Game/resume_normal.png")  no-repeat 0px 0px ;
    background-size: 100% 100%;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  .view-cv:hover{
    width: 30px;
    height: 30px;
    background: url("https://files.wondercv.com/Game/resume_hover.png")  no-repeat 0px 0px ;
    background-size: 100% 100%;
    position: absolute;
    right: 0px;
    top: 0px;
  }
  // .sign-in {
  //   width: 650px;
  //   height: 410px;
  //   position: fixed;
  //   .sign-in-bj {
  //     width: 650px;
  //     height: 410px;
  //     position: absolute;
  //     left: 0px;
  //     right: 0px;
  //     top: 0px;
  //     bottom: 0px;
  //   }
  //   .sign-in-btn {
  //     width: 274px;
  //     height: 50px;
  //     background: url("https://files.wondercv.com/Game/character/button3_normal.png") no-repeat 0px 0px;
  //     background-size: 100% 100%;
  //     position: absolute;
  //     right: 98px;
  //     bottom: 104px;
  //   }
  //   .sign-in-btn:hover {
  //     width: 274px;
  //     height: 50px;
  //     background: url("https://files.wondercv.com/Game/character/button3_hover.png") no-repeat 0px 0px;
  //     background-size: 100% 100%;
  //     position: absolute;
  //     right: 98px;
  //     bottom: 104px;
  //   }
  //   .subscribe-btn {
  //     width: 274px;
  //     height: 50px;
  //     background: url("https://files.wondercv.com/Game/character/button4_normal.png") no-repeat 0px 0px;
  //     background-size: 100% 100%;
  //     position: absolute;
  //     right: 98px;
  //     bottom: 104px;
  //   }
  //   .subscribe-btn:hover {
  //     width: 274px;
  //     height: 50px;
  //     background: url("https://files.wondercv.com/Game/character/button4_hover.png") no-repeat 0px 0px;
  //     background-size: 100% 100%;
  //     position: absolute;
  //     right: 98px;
  //     bottom: 104px;
  //   }
  // }
  .live-play {
    position: absolute;
    width: 1120px;
    height: 631px;
    padding: 10px;
    padding-top: 0px;
    .live-play-img { 
      width: 100%;
      height: 100%;
    }
    .live-play-top { 
      width: 1126px;
      height: 56px;
      position: absolute;
      left: 0;
      top: -30px;
    }
    .live-play-left {
      width: 16px;
      height: 620px;
      position: absolute;
      left: 0;
      top: 21px;
    }
    .live-play-right {
      width: 16px;
      height: 652px;
      position: absolute;
      right: -2px;
      top: -11px;
    }
    .live-play-bottom {
       width: 1110px;
      height: 16px;
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 0;
    }
    
  }
  .cv-list {
    width: 323px;
    height: 500px;
    background: url("https://files.wondercv.com/Game/resume_bg.png") no-repeat 0px 0px;
    background-size: 100% 100%;
    position: absolute;
   
    top: 155px;
    z-index: 14;
    .no-resume-tips {
      margin: 0 auto;
      width: 100px;
      margin-top: 166px;
      margin-bottom: 146px;
      .no-resume {
        margin: 0 auto;
        width: 80px;
        height: 72px;
      }
      .no-resume-text{
        text-align: center;
        font-size: 14px;
        color: #9C9C9C;
        margin-top: 6px;
      }
    }
    .resume-list {
      padding-top: 24px;
      .cv-count {
        font-size: 14px;
        color: #404040;
        margin-left: 19px;
        margin-bottom: 10px;
        font-weight: 500;
      }
      // 无在线简历模块
      .no-online-cv-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 66px;
        width: 275px;
        padding: 0 16px 0 73px;
        margin: 0 auto 15px;
        box-sizing: border-box;
        border-radius: 6px;
        background: url('https://files.wondercv.com/Game/onlineresume.png') no-repeat center/cover;

        >p {
          font-size: 14px;
          font-weight: 400;
          color: #606060;
          line-height: 20px;
        }

        >button {
          width: 80px;
          height: 28px;
          background: #FF6644;
          line-height: 28px;
          font-size: 14px;
          border-radius: 14px;
          font-weight: 400;
          color: #FFFFFF;
          padding: 0;

          //&:hover {
          //  opacity: 0.8;
          //}
        }

      }
      .online-cv-box {
        //padding-bottom: 24px;

        .online-cv-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          >h6 {
            font-size: 14px;
            font-weight: 500;
            color: #404040;
            line-height: 20px;
          }

          .online-cv-icon-box {

            >i {
              color: #9C9C9C;
              font-size: 24px;
              cursor: pointer;

              &:last-of-type {
                margin-left: 12px;
              }
            }

          }

        }

        .online-cv-content {
          display: flex;
          width: 275px;
          background: #FFFFFF;
          box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.08);
          border-radius: 6px;
          padding: 12px 16px 12px 12px;
          box-sizing: border-box;
          margin: 0 auto 15px;
          cursor: pointer;

          .online-cv-content-left {
            flex: 1;
            display: flex;
            align-items: center;

            .online-cv-avatar {
              width: 56px;
              height: 71px;
              border-radius: 4px;
              object-fit: cover;
              object-position: center;
              margin-right: 12px;
            }

            .online-cv-info {
              flex: 1;

              >span {
                max-width: 168px;
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                box-sizing: border-box;
              }

              .online-cv-title {
                font-size: 16px;
                font-weight: 500;
                color: #404040;
                line-height: 16px;
                margin-bottom: 7px;
              }

              .online-cv-tag {
                display: inline-block;
                padding: 4px 8px;
                font-size: 12px;
                font-weight: 400;
                color: #4183FF;
                background: #F5F8FF;
                border-radius: 2px;
                margin-bottom: 8px;
                border-radius: 2px;
                margin-right: 6px;

                &:last-of-type {
                  margin-right: 0;
                }

                &.orange {
                  // color: #ff6644;
                  // background: #fff6f4;
                  color: #4183FF;
                  background: #F5F8FF;
                }

                &.school {
                  max-width: 100px;
                }

                &.degree {
                  max-width: 56px;
                }
              }

              .online-cv-time {
                font-size: 12px;
                font-weight: 400;
                color: #9C9C9C;
                line-height: 12px;
              }
            }

          }

          .online-cv-content-right {
            width: 70px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-end;

            .online-cv-btn {
              font-size: 12px;
              line-height: 12px;
              font-weight: 400;
              color: #FF6644;
              padding: 4px 11px;
              border-radius: 15px;
              background: #ffffff;
              border: 1px solid #FF6644;

              //&:hover {
              //  color: #ffffff;
              //  background: #ff6644;
              //}
            }
          }
        }

      }
      .resume-item {
        display: flex;
        align-items: center;
        width: 275px;
        height: 71px;
        border-radius: 6px;
        border: 1px solid #ECECEC;
        margin: 0 auto;
        padding-left: 9px;
        margin-bottom: 10px;
        .cv-avatar {
          width: 38px;
          height: 47px;
          object-fit: cover;
          margin-right: 12px;
          border-radius: 4px;
        }
        .cv-name {
          font-size: 16px;
          color: #404040;
          font-weight: 500;
          width: 173px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .cv-score {
          color: #4183FF;
          font-size: 12px;
          background: #f5f8ff;
          display: inline-block;
          padding: 4px 8px;
          margin-top: 7px;
        }
        .cv-update-time {
          font-size: 12px;
          color: #9C9C9C;
          margin-top: 7px;
        }
      }
      .create-cv {
        width: 272px;
        height: 44px;
        background: url(https://files.wondercv.com/Game/resume_button_normal.png) no-repeat 0px 0px;
        background-size: 100% 100%;
        margin: 0 auto;
      }
      //.create-cv:hover {
      //  width: 272px;
      //  height: 44px;
      //  background: url(https://files.wondercv.com/Game/resume_button_hover.png) no-repeat 0px 0px;
      //  background-size: 100% 100%;
      //  margin: 0 auto;
      //}
    }
    //.resume-item:hover {
    //  display: flex;
    //  align-items: center;
    //  width: 275px;
    //  height: 95px;
    //  border-radius: 6px;
    //  border: 1px solid #ECECEC;
    //  margin: 0 auto;
    //  padding-left: 9px;
    //  box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.12);
    //  margin-bottom: 10px;
    //}
  }
  .view-cv-outer {
    padding-left: 20px;
    position: absolute;
    right: 10px; 
    top: 46px; 
    width: 30px; 
    height: 30px;
    z-index: 10;
  }
  .close-btn{
    width: 20px;
    height: 20px;
    background: url("https://files.wondercv.com/Game/character/close/default.png")  no-repeat 0px 0px ;
    background-size: 100% 100%;
    position: absolute;
    right: 0px;
    top: -34px;
    z-index: 14;
  }
  //.close-btn:hover{
  //  width: 20px;
  //  height: 20px;
  //  background: url("https://files.wondercv.com/Game/character/close/hover.png")  no-repeat 0px 0px ;
  //  background-size: 100% 100%;
  //  position: absolute;
  //  right: 0px;
  //  top: -34px;
  //  z-index: 13;
  //}
  }
</style>